const routes = [
  {
    path: "/h5/index",
    name: "Index",
    component: () => import("@/views/main.vue")
  },
  {
    path: "/h5/download/app",
    name: "AppDownload",
    component: () => import("@/views/download/app-download-new.vue"),
    meta: {
      title: "钱收收下载"
    }
  },
  {
    path: "/h5/shopdownload/app",
    name: "AppDownload",
    component: () => import("@/views/download/shop-download.vue"),
    meta: {
      title: "商城下载"
    }
  },
  /*{
    path: '/h5/agreement/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import('@/views/agreement/privacy-policy.vue'),
    meta:{
      title: '隐私政策'
    }
  },*/
  {
    path: "/h5/goodsDetail",
    name: "goodDetail",
    component: () => import("@/views/goods-detail/index.vue"),
    meta: {
      title: "商品详情"
    }
  },
  {
    path: "/h5/bind-phone",
    name: "bindPhone",
    component: () => import("@/views/goods-detail/bind-phone.vue"),
    meta: {
      title: "绑定手机号"
    }
  },
  {
    path: "/h5/college",
    name: "college",
    component: () => import("@/views/college/index.vue"),
    meta: {
      title: "新手教程"
    }
  },
  {
    path: "/h5/college/videoPlayer",
    name: "video-player",
    component: () => import("@/views/college/videoPlayer.vue"),
    meta: {
      title: "新手教程"
    }
  },
  {
    path: "/h5/uploadFile/index",
    name: "uploadFile",
    component: () => import("@/views/uploadFile/index.vue"),
    meta: {
      title: "上传文件"
    }
  },
  {
    path: "/h5/agreement/maiYaGO/privacyPolicy",
    name: "MYGPrivacyPolicy",
    component: () => import("@/views/agreement/maiYaGO/privacyPolicy.vue"),
    meta: {
      title: "隐私政策"
    }
  },
  {
    path: "/h5/agreement/heiBaiMa/privacyPolicy",
    name: "MYGPrivacyPolicy",
    component: () => import("@/views/agreement/heiBaiMa/privacyPolicy.vue"),
    meta: {
      title: "隐私政策"
    }
  },
  {
    path: "/h5/agreement/privacyPolicy",
    name: "privacyPolicy",
    component: () => import("@/views/agreement/privacyPolicy.vue"),
    meta: {
      title: "隐私政策"
    }
  },
  {
    path: "/h5/agreement/userAgreement",
    name: "userAgreement",
    component: () => import("@/views/agreement/userAgreement.vue"),
    meta: {
      title: "用户协议"
    }
  },
  {
    path: "/h5/test",
    name: "test",
    component: () => import("@/views/test/index.vue"),
    meta: {
      title: "测试"
    }
  },
  {
    path: "/h5/take-out",
    name: "takeOut",
    component: () => import("@/views/take-out/index.vue"),
    meta: {
      title: "外卖优惠"
    }
  },
  {
    path: "/h5/instructions",
    name: "instructions",
    component: () => import("@/views/instructions/index.vue"),
    meta: {
      title: "比价订单说明"
    }
  },
  {
    path: "/h5/instructions/meanOne",
    name: "meanOne",
    component: () => import("@/views/instructions/meanOne.vue"),
    meta: {
      title: "比价订单说明"
    }
  },
  {
    path: "/h5/instructions/meanTwo",
    name: "meanTwo",
    component: () => import("@/views/instructions/meanTwo.vue"),
    meta: {
      title: "比价订单说明"
    }
  },
  {
    path: "/h5/instructions/meanThree",
    name: "meanThree",
    component: () => import("@/views/instructions/meanThree.vue"),
    meta: {
      title: "比价订单说明"
    }
  },
  {
    path: "/h5/instructions/meanFour",
    name: "meanFour",
    component: () => import("@/views/instructions/meanFour.vue"),
    meta: {
      title: "比价订单说明"
    }
  },
  {
    path: "/skip-wechat",
    name: "skipWechat",
    component: () => import("@/views/qrcode/skip-wechat.vue"),
    meta: {
      title: "比价订单说明"
    }
  },
  {
    path: "/q/:id",
    name: "QRCode",
    component: () => import("@/views/qrcode/index.vue"),
    meta: {
      title: "\u200b"
    }
  },
  {
    path: "/weChatPublicMsgLink/:id",
    name: "weChatPublicMsgLink",
    component: () => import("@/views/land/index.vue"),
    meta: {
      title: "\u200b "
    }
  },
  {
    path: "/ql/:id",
    name: "land",
    component: () => import("@/views/land/index.vue"),
    meta: {
      title: "\u200b"
    }
  },

  // {
  //   path: "/h5/product-detail",
  //   name: "ProductDetail",
  //   component: () => import("@/views/product-detail/index.vue"),
  //   meta: {
  //     title: "二维码"
  //   }
  // },
  {
    path: "/qssProductDetail",
    name: "ProductDetail",
    component: () => import("@/views/product-detail/index.vue"),
    meta: {
      title: "商品详情"
    }
  },
  {
    path: "/h5/chat-content",
    name: "chatContent",
    component: () => import("@/views/chat/content.vue"),
    meta: {
      title: "聊天信息"
    }
  },
  {
    path: "/h5/chat-conversation",
    name: "chatConversation",
    component: () => import("@/views/chat/conversation.vue"),
    meta: {
      title: "聊天信息"
    }
  },
  {
    path: "/h5/chat-notice",
    name: "chatNotice",
    component: () => import("@/views/chat/notice.vue"),
    meta: {
      title: "公告"
    }
  },
  {
    path: "/h5/chat-list",
    name: "chatList",
    component: () => import("@/views/chat/list.vue"),
    meta: {
      title: "聊天列表"
    }
  },
  {
    path: "/h5/look-member",
    name: "lookMember",
    component: () => import("@/views/chat/look-member.vue"),
    meta: {
      title: "查看成员"
    }
  }
];
export default routes;
